import axios from 'axios'

/**
 * 用户资料相关API
 * 处理与用户资料相关的接口请求
 */
export default {
  /**
   * 根据用户ID查询资料
   * @param {string|number} userId - 用户ID
   * @returns {Promise} - 用户资料详情
   */
  getByUserId(userId) {
    return axios({
      url: '/user-service/api/v1/user-profiles/get-by-userId',
      method: 'get',
      params:  {userId} 
    })
  },
  

  saveOrUpdate(params) {
    // 提取需要的参数，忽略其他不必要的参数

    
    return axios({
      url: '/user-service/api/v1/user-profiles/save-or-update',
      method: 'post',
      data: params
  })
}
}